if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
$(document).on('submit', '.search-form', function (e) {
    e.preventDefault();

    let form = $(this);
    let formData = form.serializeArray();

    let searchWord = 'q';
    let filterParam = function (field) {
        return field.name === searchWord;
    }

    let value = formData.filter(filterParam)[0].value;
    let searchWordTest = value.replaceAll(' ', '_');

    window.location.href = '/search/q/' + searchWordTest;
});

$('#searchInputForm').on('focusout', function() {
    $('.search-form').trigger('submit');
});


// HTMLCollection has no native forEach in any browser (unlike NodeList)
if ('HTMLCollection' in window && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

/**
 * Generates an HTML <span> element with an SVG mask, similar to SvgHelper::icon()
 *
 * @param {string} iconPath - Path to the SVG icon
 * @param {Object} options - Element attributes (class, style, etc.)
 * @param {string} height - Icon height (default is '24px')
 * @param {string} width - Icon width (default is '24px')
 * @returns {string} HTML string of the <span> element
 */
function createSvgIconHTML(iconPath, options = {}, height = '24px', width = '24px') {
    const styles = {
        '-webkit-mask-image': `url(${iconPath})`,
        'mask-image': `url(${iconPath})`,
        'height': height,
        'width': width,
    };

    if (options.style) {
        if (typeof options.style === 'string') {
            options.style.split(';').forEach(style => {
                if (style.includes(':')) {
                    const [key, value] = style.split(':');
                    styles[key.trim()] = value.trim();
                }
            });
        } else if (typeof options.style === 'object') {
            Object.assign(styles, options.style);
        }
        delete options.style;
    }

    const styleString = Object.entries(styles)
        .map(([key, value]) => `${key}: ${value}`)
        .join('; ');

    const classList = ['svg-mask'];
    if (options.class) {
        if (typeof options.class === 'string') {
            classList.push(...options.class.split(/\s+/));
        } else if (Array.isArray(options.class)) {
            classList.push(...options.class);
        }
        delete options.class;
    }

    const attrs = Object.entries(options)
        .map(([key, value]) => `${key}="${String(value).replace(/"/g, '&quot;')}"`)
        .join(' ');

    return `<span class="${classList.join(' ')}" style="${styleString};"${attrs ? ' ' + attrs : ''}></span>`;
}

const sidebarContentTemplateCommon = `
    <div class="text-icon text-14 text-warning">
        ${createSvgIconHTML('/resources/img/icons/sliders.svg')}
        Фильтры
    </div>
    <button class="sidebar-close-btn">
        ${createSvgIconHTML('/resources/img/icons/x-circle.svg')}
    </button>
`;

const sidebarContentTemplateBackButton = `
    <div class="sidebar-back-button text-icon text-14 text-success">
        ${createSvgIconHTML('/resources/img/icons/arrow-circle-left.svg')}
        Назад
    </div>
    <button class="sidebar-close-btn">
        ${createSvgIconHTML('/resources/img/icons/x-circle.svg')}
    </button>
`;

const openSidebar = (callback) => {
    const $menu = $('.mobile-filter-menu');
    $menu.css({
        'opacity': '0',
        'transition': 'opacity 0.2s linear'
    });

    setTimeout(() => {
        if (!$('.sidebar-overlay').length) {
            $menu.before('<div class="sidebar-overlay"></div>');
        }
        $menu.addClass('mobile-filter-menu--sidebar-mode');
        $('body').addClass('lock-scroll');

        if (callback) {
            callback($menu);
        }

        setTimeout(() => {
            $menu.css('opacity', '1');
        }, 50);
    }, 200);
};

const addSidebarFooter = ($menu) => {
    if (!$menu.find('.sidebar-footer').length) {
        $menu.append(`
            <div class="sidebar-footer">
                <button class="btn btn-primary sidebar-footer__button sidebar-footer__button--apply">Применить</button>
                <button class="btn btn-white sidebar-footer__button sidebar-footer__button--reset-all">Очистить</button>
            </div>
        `);
    }
};

const setDataAttributeIfSidebarModeExists = () => {
    if ($('.mobile-filter-menu--sidebar-mode').length) {
        $('.mobile-filter-menu').data('has-filters-to-wrap', true);
    }
}

const wrapFilterItems = ($menu) => {
    const $fieldsToWrap = $menu.find('[data-field="isOffline"], [data-field="isOnline"]');
    if ($fieldsToWrap.length && !$fieldsToWrap.parent().hasClass('filter-items-wrapper')) {
        $fieldsToWrap.wrapAll('<div class="filter-items-wrapper"></div>');
    }

    if ($fieldsToWrap.length === 1) {
        console.log('wrapFilterItems if');
        $fieldsToWrap.first().addClass('checkbox-filter-item--single');
    }
};

const closeSidebarWithFilters = () => {
    const $menu = $('.mobile-filter-menu');

    $menu.css('opacity', '0');

    setTimeout(() => {
        $menu.removeClass('mobile-filter-menu--sidebar-mode');
        $('.sidebar-overlay').remove();
        $menu.find('.sidebar-header').remove();
        $menu.find('.sidebar-footer').remove();
        $('body').removeClass('lock-scroll');

        $menu.find('.filter-items-wrapper').each(function() {
            $(this).replaceWith($(this).contents());
        });

        $menu.find('.filter-item').show();
        $menu.find('.filter-item__list').hide();
        $menu.removeClass('mobile-filter-menu--with-opened-filter-item');
        $('.filter-item--opened').removeClass('filter-item--opened');

        setTimeout(() => {
            $menu.css('opacity', '1');
        }, 50);
    }, 200);
}

var app = {
    mobile: false,
    localStorageGoToOfflineTicketFormKey: 'go-to-offline-ticket-form-storage',
    options: {
        assetsFolder: "/",
    },
    init: function () {
        if (window.jsConfig) {
            this.options = $.extend({}, this.options, window.jsConfig)
        }

        app.mobile = app.isMobile();
        this.mobileMenu();

        if (!app.mobile) {
            this.initDesktopMenu();
        }

        objectFitImages($('.grid-card__figure img'));

        UIkit.util.on('.main-navigation-menu-wrapper', 'active', function () {
            app.initDesktopMenu(true);
            app.header_fixed = true;
        });

        UIkit.util.on('.main-navigation-menu-wrapper', 'inactive', function (e) {
            if (app.header_fixed) {
                app.header_fixed = false;
                app.initDesktopMenu(false);
            }

        });

        UIkit.util.on('.inline-accord', 'shown', function (e) {
            $('.modal-page--open').trigger('modal:hchange');
        });

        this.initMainSlider();
        this.mobileSearch();
        this.dropDownForm();
        this.mask();
        this.initPhoneCodeInput();
        this.initShowHidePwd();
        this.initDetailSpoilers();
        this.initDatePickers();
        if (!app.mobile) {
            this.customSelects();
        }
        this.customDropdown();
        this.initNewPhoneInput();
        this.stickyBuyButtons();
        //this.filters();
        this.sliders();
        this.initPersonalMenus();
        this.initVideoSlider();
        this.initContactsMap();
        this.initPreviewSlider();
        this.initFavBtns();
        this.initModalPages();
        this.initCustomFileImgInput();
        this.initImgCropper();
        this.initAnchors();
        this.initSub();
        this.initAjaxLinks();
        this.initCustomEvents();
        this.setBirthdayDateDatepickerValue();
        this.initGetActionCatch();
        this.initAnchorScrollToElement();
        this.checkLocalStorage()
        if (app.mobile) {
            this.initCourseNav();
        }
    },
    resetForm: function ($form) {
        if ($form.length <= 0) {
            return false;
        }

        $form[0].reset();
    },
    pageTransformForModal: function (modalState) {
        switch (modalState) {
            case 'opened':
                $('body').css({});
                break;
            case 'closed':
                break;
        }
    },
    initAnchors: function () {
        $(document).on('click', '.js-anchor', function (e) {
            e.preventDefault();
            var target = $(this.hash);
            if (target.length) {
                if ($('.modal-page.modal-page--open').length > 0) {
                    $('.modal-page.modal-page--open').find('.modal-page__close-btn').click();
                }
                $('html, body').animate({
                    scrollTop: target.offset().top - 70
                }, 1000);
            }
        });
    },
    initSub: function () {
        $('.sub-agree-checkbox').on('click', function () {
            this.setCustomValidity('');
        });

        $(document).on('click', '.js-sub-buy-btn', function (e) {
            e.preventDefault();
            let goto = this.dataset.url;
            const $subscriptionCard = $(this).closest('.subscription-card');
            const $subAgreeCheckbox = $subscriptionCard.find('.sub-agree-checkbox');
            const checkBox = $('#' + this.dataset.code);

            if (checkBox.is(':checked')) {
                goto += '&paymentSystem=' + checkBox.data('paymentSystem');
            }

            if ($subAgreeCheckbox.length && !$subAgreeCheckbox.prop('checked')) {
                if (app.isMobile()) {
                    $('html, body').animate({
                        scrollTop: $subAgreeCheckbox.offset().top - 200
                    }, 500);
                }
                const $label = $subAgreeCheckbox.parent();
                $label.addClass('sub-agree-invalid');
                setTimeout(() => {
                    $label.removeClass('sub-agree-invalid');
                    $subAgreeCheckbox[0].setCustomValidity(
                        'Пожалуйста, ознакомьтесь и примите условия Пользовательского соглашения и Политики конфиденциальности'
                    );
                    $subAgreeCheckbox[0].reportValidity();
                }, 500);
            } else {
                location.href = goto;
            }
        });

        $(document).on('click', '.payment-system-container-recurrent-subscription > div', function () {
            let parentElement = $(this).parent( ".payment-system-container-recurrent-subscription" );
            parentElement.children('div').removeClass('active');

            $(this).addClass('active');

            parentElement.find('input[type=checkbox]').prop('checked', false);

            $(this).find('input[type=checkbox]').prop('checked', true);
        });

    },
    initCustomEvents: function () {
        $(document).on('modal:hchange', '.modal-page--open', function () {
            var modalHeight = $(this).outerHeight(true);
            $('.page-wrap').css({
                'height': modalHeight + 'px',
                'overflow': 'hidden'
            });
        });

        const accordions1 = $('#single-accordion-1');
        const accordions2 = $('#single-accordion-2');

        UIkit.util.on(accordions1, "show" , function(){
            var opened = $(accordions2).children('.uk-open').index();
            if (opened > -1) {
                UIkit.accordion(accordions2).toggle(opened);
            }
        });
        UIkit.util.on(accordions2, "show" , function(){
            var opened = $(accordions1).children('.uk-open').index();
            if (opened > -1) {
                UIkit.accordion(accordions1).toggle(opened);
            }
        });

        $(document).on('click', '.main-content__right-side .bought-info--video', function (e) {
            if (app.isMobile()) {
                var eTarget = e.target;
                if (!$(eTarget).is('.modal-page-opener')) {
                    var $videoBlock = $('.video-block__slider');
                    if ($videoBlock.length > 0) {
                        $('html, body').animate({
                            scrollTop: $('.main-content').offset().top - 350
                        }, 1000);
                    }
                }
            }
        });

        $('.course__purchased-program-block').on('click', '.video-start', function () {
            let videoUrl = $(this).data('link');
            let toReplace = $(this).parent();

            function playCustomVideo(videoUrl, container) {
                const isMobile = app.isMobile();
                const videoHeight = isMobile ? '202px' : '414px';
                const iframeElement = `<iframe src="about:blank" width="100%" height="${videoHeight}" frameborder="0" allowfullscreen style="background: #000;"></iframe>`;
                container.html(iframeElement);

                const iframe = container.find('iframe')[0];
                if (iframe) {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    iframeDoc.open();
                    iframeDoc.write(`
                <html>
                    <body style="margin:0;padding:0;overflow:hidden;">
                        <video controls autoplay playsinline controlsList="nodownload" width="100%" height="100%" style="background: #000;">
                            <source src="${videoUrl}" type="video/mp4">
                            Your browser does not support the video tag.
                        </video>
                        <style>
                            video::-internal-media-controls-download-button {
                                display:none !important;
                            }
                            video::-webkit-media-controls-enclosure {
                                overflow:hidden !important;
                            }
                            video::-webkit-media-controls-panel {
                                width: calc(100% + 30px);
                            }
                        </style>
                    </body>
                </html>
            `);
                    iframeDoc.close();

                    $(iframe).on('click', function(e) {
                        e.stopPropagation();
                    });
                }
            }

            if ($(this).data('inoagent') == 1) {
                app.playInoagentWarningScreen(toReplace, () => {
                    if (videoUrl.includes('cloudfront.net')) {
                        playCustomVideo(videoUrl, toReplace);
                    } else {
                        toReplace.replaceWith(`<iframe src="${videoUrl}" frameborder="0" width="100%" height="${toReplace.width() / 1.777}" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`);
                    }
                });
            } else {
                if (videoUrl.includes('cloudfront.net')) {
                    playCustomVideo(videoUrl, toReplace);
                } else {
                    toReplace.replaceWith(`<iframe src="${videoUrl}" frameborder="0" width="100%" height="${toReplace.width() / 1.777}" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`);
                }
            }

            if ($('.thumb-wrap-free-video').length > 0) {
                $('.thumb-wrap-free-video').css('display', 'block');
            }
        });

        $(document).on('click', '#open-window-link', function (e) {
           e.preventDefault();
           let newWin = window.open(
             $(this).attr('data-href'),
             "_blank",
             `width=${app.isMobile() ? screen.width : screen.width / 2},
             height=${app.isMobile() ? screen.height : screen.height / 2},
             left=${screen.width / 4},
             top=100`
           );
        });

        let commentsFotoramaDiv = $('.comments-fotorama');
        if (commentsFotoramaDiv.length) {
            commentsFotoramaDiv.data('height', $('.comments_slide')[0].clientHeight);
            commentsFotoramaDiv = commentsFotoramaDiv.fotorama({ nav: false });

            let fotorama = commentsFotoramaDiv.data('fotorama');
            $('.comments-fotorama').on('fotorama:showend', function () {
                fotorama.resize({
                    height: $(".comments-fotorama .fotorama__active").find('.comments_slide')[0].clientHeight
                }, 100);
            }).fotorama();
        }

        $(document).on('click touchend', '.spoiler-comment-btn', function () {
            let commentsFotoramaDiv = $('.comments-fotorama');
            let fotorama = commentsFotoramaDiv.data('fotorama');

            fotorama.activeFrame.$stageFrame.find('.spoiler-comment-btn').hide();
            fotorama.activeFrame.$stageFrame.find('.comment_slider_message_short').hide();
            fotorama.activeFrame.$stageFrame.find('.comment_slider_message').show();

            fotorama.resize({
                height: $(".comments-fotorama .fotorama__active").find('.comments_slide')[0].clientHeight
            }, 100).resize();
        });

        $('.fotorama').on('fotorama:show', function (e, fotorama, extra) {
            $('.fotorama__stage__frame').each(function () {
                $(this).find('.spoiler-comment-btn').show();
                $(this).find('.comment_slider_message_short').show();
                $(this).find('.comment_slider_message').hide();
            });
        });

        $(document).on('click', '.ticket-info', function () {
            $(this).find('div.ticket-info__body').slideToggle();
            $(this).find('div > span').toggleClass('opened');
            $(this).find('i').toggleClass('fa-plus').toggleClass('fa-minus');
        });

        document.addEventListener('DOMContentLoaded', function() {
            document.body.addEventListener('click', function(e) {
                if (e.target.closest('[data-prevent-link]') && !e.target.closest('.send-gift-translation')) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });

        $(document).on('click', '.send-gift-translation', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const $modal = $('.send-gift-translation-modal').fadeIn();

            let $buttons = $modal.find('.send');
            let $buttonsText = $buttons.find('.button-text');

            $buttons.prop('disabled', false)
                .removeClass('btn-disabled')
                .addClass('btn-primary');
            $buttonsText.text('Отправить');
        });

        $(document).on('click', '.send-gift-translation-modal .send', function () {
            const orderId = $(this).data('order-id');
            if (orderId === undefined) return;

            app.buttonStartLoading(this);

            let $buttonText = $(this).find('.button-text');

            $.post('/user-translations/resend-gift-email', { orderId })
                .done(({ result }) => {
                    if (result === 'success') {
                        $buttonText.text('Отправлено');
                    } else {
                        $buttonText.text('Ошибка');
                    }
                })
                .fail(() => {
                    $buttonText.text('Ошибка');
                })
                .always(() => {
                    app.buttonStopLoading(this);
                    $(this).prop('disabled', true)
                        .removeClass('btn-primary')
                        .addClass('btn-disabled');
                });
        });

        $(document).on('click', '.send-gift-translation-modal .close-modal', function () {
            $('.send-gift-translation-modal').fadeOut();
        });
    },
    initAjaxLinks: function () {
        $(document).on('click', '.js-ajax-link', function (e) {
            e.preventDefault();
            var endpoint = this.dataset.href;
            if (!endpoint) {
                endpoint = this.href;
            }
            var method = this.dataset.method;
            if (!method) {
                method = 'GET';
            }

            $.ajax({
                url: endpoint,
                method: method,
                dataType: 'json',
                success: function (response) {
                    switch (response.status) {
                        case 'success':
                            if (response.redirectUrl) {
                                location.href = response.redirectUrl;
                            } else if (response.reload) {
                                location.reload();
                            }

                            break;
                        case 'failed':
                            $('#js-ajax-link-error').removeAttr('hidden');
                            $('#js-ajax-link-error').children('span').html(response.errors[0]);
                            break;
                    }

                }
            });
        })
    },
    isUserAuthorized: function () {
        return this.options.user && this.options.user.authorized
    },
    setUserState: function (user) {
        this.options.user = {
            authorized: true,
            data: user.data,
        };
    },
    openAuthModal: function () {
        const authWrapper = $('.user-account-text-auth-wrapper');
        const userAccount = $('#user-account');

        if (userAccount.length) {
            if (userAccount.css('display') === 'none') {
                authWrapper.click();
            }
            $('html, body').animate({
                scrollTop: authWrapper.offset().top - 100
            }, 300);
        }
    },
    countClickBuyerButton: function (lectureId, lectureType) {
        if (app.isUserAuthorized()) {
            var userConfig = window.jsConfig.user;

            if (userConfig.data.id && lectureId && lectureType) {
                let userId = userConfig.data.id;

                $.ajax({
                    url: '/buyer-click-counter/set-count-click',
                    type: 'post',
                    data: {
                        userId: userId,
                        lectureId: lectureId,
                        lectureType: lectureType,
                    }
                })
            }
        }
    },

    initImgCropper: function ($img) {
        $img = typeof $img !== 'undefined' ? $img : false;

        if ($img) {
            var $cropperImg = $img;
        } else {
            var $cropperImg = $('.cropper-img');
        }

        if ($cropperImg.length > 0) {
            var cropperOptions = {
                viewMode: 1,
                aspectRatio: 1,
                guides: false,
                background: false,
                responsive: true,
                zoomable: false,
                minCropBoxWidth: 40,
                minCropBoxHeight: 40
            };

            var $dataInput = $($cropperImg.attr('data-cropper-data-input'));
            var cropInitData = $dataInput.val();
            if (cropInitData) {
                cropperOptions.data = JSON.parse(cropInitData);
            }

            $cropperImg.cropper(cropperOptions).on('cropmove', function () {
                var cropData = this.cropper.getData();
                if (cropData && $dataInput.length > 0) {
                    $dataInput.val(JSON.stringify(cropData));
                }
            }).on('ready', function () {
                var cropData = this.cropper.getData();
                if (cropData && $dataInput.length > 0) {
                    $dataInput.val(JSON.stringify(cropData));
                }
            });
        }
    },
    initModalPages: function () {
        $(document).on('click', '.modal-page-opener', function (e) {
            e.preventDefault();
            const targetModalPage = this.hash;
            if (typeof targetModalPage != 'undefined') {
                const $targetModal = $(targetModalPage);
                if ($targetModal.length === 0) {
                    return false;
                }

                let activeAccordionLi = $('.uk-accordion').find('li:first');
                activeAccordionLi.addClass('uk-open');
                activeAccordionLi.find('.uk-accordion-content').removeAttr('hidden');

                var modalHeight = $targetModal.outerHeight(true);
                $('.modal-page--open').find('.modal-page__close-btn').click();
                $targetModal.addClass('modal-page--open').fadeIn(100, function () {
                    $('.page-wrap').css({
                        'height': modalHeight + 'px',
                        'overflow': 'hidden'
                    });
                    const $stickyButtons = $('.sticky-buttons');
                    if ($stickyButtons.length) {
                        $stickyButtons.hide().addClass('sticky-buttons--while-modal');
                    }
                    $('html,body').scrollTop(0);
                });
            }
        });

        $(document).on('click', '.modal-page-opener-gift', function (e) {
            e.preventDefault();
            const targetModalPage = this.hash;
            if (typeof targetModalPage != 'undefined') {
                const $targetModal = $(targetModalPage);
                if ($targetModal.length === 0) {
                    return false;
                }

                let activeAccordionLi = $('.uk-accordion').find('li:first');
                activeAccordionLi.removeClass('uk-open');
                activeAccordionLi.find('.uk-accordion-content').attr('hidden', 'hidden');

                let giftAccordionLi = $('.accordionGift');
                giftAccordionLi.addClass('uk-open');
                giftAccordionLi.find('.uk-accordion-content').removeAttr('hidden');

                const modalHeight = $targetModal.outerHeight(true);
                $('.modal-page--open').find('.modal-page__close-btn').click();
                $targetModal.addClass('modal-page--open').fadeIn(100, function () {
                    $('.page-wrap').css({
                        'height': modalHeight + 'px',
                        'overflow': 'hidden'
                    });
                    const $stickyButtons = $('.sticky-buttons');
                    if ($stickyButtons.length) {
                        $stickyButtons.hide().addClass('sticky-buttons--while-modal');
                    }
                    $('html,body').scrollTop(0);
                });
            }
        });

        $(document).on('click', '.modal-page__close-btn', function (e) {
            e.preventDefault();
            const $modalPage = $(this).closest('.modal-page');
            $modalPage.removeClass('modal-page--open').fadeOut(100);
            $('.page-wrap').css({ height: '', overflow: '' });

            const $mainContent = $('.main-content__right-side');
            const $headerTop = $('.main-header__top');
            if ($mainContent.length && $headerTop.length) {
                $('html, body').animate({
                    scrollTop: $mainContent.offset().top - $headerTop.height() - 10
                }, 700);
            }

            $('.sticky-buttons').removeClass('sticky-buttons--while-modal');
        });
    },
    renderMoreMenu: function () {
        return `
        <li class="main-navigation-menu__list-item dotted-more-items available">
            <a href="javascript:;">
                ${createSvgIconHTML('/resources/img/icons/dots-horizontal.svg')}
            </a>
            <ul class="main-navigation-menu__list-item-dropdown"></ul>
        </li>`;
    },
    setFormLoadingState: function ($form, loading) {
        loading = typeof loading !== 'undefined' ? loading : true;
        $form.toggleClass('ajax-form-loading', loading);
        $form.find('[type="submit"]').each(function () {
            if (loading) {
                app.buttonStartLoading(this);
            } else {
                app.buttonStopLoading(this);
            }
        });
        $form.find('.btn-disabled').toggleClass('btn-disabled', loading);
    },
    buttonStartLoading: function (button) {
        const $btn = $(button);
        if ($btn.length === 0) return;

        if (!$btn.is(':visible')) return;

        if (typeof $btn.data('original-width') === 'undefined') {
            $btn.data('original-width', $btn[0].style.width || null);
        }

        const currentWidth = Math.ceil($btn.outerWidth());
        if (currentWidth > 0) {
            $btn.css('width', currentWidth + 'px');
        }

        const $text = $btn.find('.button-text');
        const $loader = $btn.find('.button-loader');

        if ($text.length) {
            if (typeof $btn.data('original-button-text-display') === 'undefined') {
                $btn.data('original-button-text-display', $text[0].style.display || '');
            }
            $text.css('display', 'none');
        }

        if ($loader.length) {
            if (typeof $btn.data('original-button-loader-display') === 'undefined') {
                $btn.data('original-button-loader-display', $loader[0].style.display || '');
            }
            $loader.css('display', 'inline-block');
        }

        $btn.addClass('btn-loading');
        if (!$btn.prop('disabled')) {
            $btn.data('was-not-disabled', true);
            $btn.prop('disabled', true);
        }
    },
    buttonStopLoading: function (button) {
        const $btn = $(button);
        if ($btn.length === 0) return;

        const originalWidth = $btn.data('original-width');
        if (typeof originalWidth !== 'undefined') {
            if (originalWidth === null || originalWidth === '') {
                $btn.css('width', '');
            } else {
                $btn.css('width', originalWidth);
            }
            $btn.removeData('original-width');
        } else {
            $btn.css('width', '');
        }

        const $text = $btn.find('.button-text');
        const $loader = $btn.find('.button-loader');

        if ($text.length) {
            const txtDisp = $btn.data('original-button-text-display');
            $text.css('display', typeof txtDisp === 'undefined' ? '' : txtDisp);
            $btn.removeData('original-button-text-display');
        }

        if ($loader.length) {
            const ldrDisp = $btn.data('original-button-loader-display');
            $loader.css('display', typeof ldrDisp === 'undefined' ? '' : ldrDisp);
            $btn.removeData('original-button-loader-display');
        }

        $btn.removeClass('btn-loading');

        if ($btn.data('was-not-disabled')) {
            $btn.prop('disabled', false);
            $btn.removeData('was-not-disabled');
        }
    },
    initShowHidePwd: function () {
        $(document).on('click', '.show-hide-pwd-btn', function (e) {
            e.preventDefault();
            var $pwdInput = $(this).parent().find('.pwd-input');
            if ($(this).hasClass('show-hide-pwd-btn--toggled')) {
                $(this).removeClass('show-hide-pwd-btn--toggled');
                $pwdInput.attr('type', 'password');
            } else {
                $(this).addClass('show-hide-pwd-btn--toggled');
                $pwdInput.attr('type', 'text');
            }
        })
    },
    initDetailSpoilers: function () {
        var $expandables = $('.spoiler-expandable');
        var spoilerBtnTextDefault = 'Развернуть описание';

        if ($expandables.length > 0) {
            $expandables.each(function () {
                var spoilerBtnText = spoilerBtnTextDefault;
                var dataSpoilerTxt = $(this).attr('data-spoilerbtntxt');
                if (dataSpoilerTxt) {
                    spoilerBtnText = dataSpoilerTxt;
                }
                $(this).after(`<button type="button" class="btn btn-outline-secondary spoiler-btn mt-26">${spoilerBtnText}</button>`);
            });
        }

        $(document).on('click', '.spoiler-btn', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $expandable = $this.prev('.spoiler-expandable');
            if ($expandable.length > 0) {
                $expandable.slideDown(200, function () {
                    $this.fadeOut(2);
                    UIkit.sticky('.main-content__right-side .sticky-container', {
                        offset: $('.main-navigation-menu-wrapper').height() + 5,
                        media: 960,
                        bottom: '.page-wrap'
                    });
                });
            }
        });

        if ($('.main-content__right-side .sticky-container').length) {
            UIkit.sticky('.main-content__right-side .sticky-container', {
                offset: $('.main-navigation-menu-wrapper').height() + 5,
                media: 960,
                bottom: '.page-wrap'
            });
        }
    },
    reCheckSticky: function () {
        $.each($('.uk-sticky'), function (index, val) {
            window.dispatchEvent(new Event('resize'));
        });
    },
    initDesktopMenu: function () {
        const $ovb = $('.main-navigation-menu-wrapper');
        $ovb.removeClass('overflow-visible');
        $('.main-navigation-menu__list-desktop-search__close').trigger('click');
        const $dottedMainMenuItem = $('.main-navigation-menu__list-item.dotted-more-items');
        const $mainHeaderRight = $('.main-header__right');
        const menuItemRightSpace = 65;

        if ($dottedMainMenuItem.length > 0) {
            $('.__cloned-to-more').removeClass('__cloned-to-more');
            $dottedMainMenuItem.remove();
        }

        const moreItems = [];
        const $moreMenuItem = $(app.renderMoreMenu());

        $('.main-navigation-menu__list-item:visible').get().reverse().forEach(function (element, index) {
            const menuItem = $(element);

            if (index === 0) {
                const overlapX = Math.floor(menuItem.offset().left + menuItem.outerWidth()) >= Math.floor($mainHeaderRight.offset().left);

                if (overlapX) {
                    const $cloneItem = menuItem.clone();
                    if (!menuItem.is('.dotted-more-items')) {
                        moreItems.unshift($cloneItem);
                    }
                    menuItem.addClass('__cloned-to-more');
                }
            } else {
                const overlapX = Math.floor((menuItem.offset().left + menuItem.outerWidth() + menuItemRightSpace)) >= Math.floor($mainHeaderRight.offset().left);

                if (overlapX) {
                    const $cloneItem = menuItem.clone();
                    if (!menuItem.is('.dotted-more-items')) {
                        moreItems.unshift($cloneItem);
                    }
                    menuItem.addClass('__cloned-to-more');
                }
            }
        });

        if (moreItems.length > 0) {
            $moreMenuItem.find('ul').append(moreItems);
            $moreMenuItem.appendTo($('.main-navigation-menu-item--ul'));
        }

        $ovb.addClass('overflow-visible');
    },
    playInoagentWarningScreen: function (videoContainer, callback) {
        if ($('.fotorama__inoagent-text').length > 0) {
            return;
        }

        if($('#inoagentText').length > 0) {
            var inoAgentText = '<p class="fotorama__inoagent-text">' + $('#inoagentText').html() + '</p>';
            inoAgentText = inoAgentText.replace('*', '');
        } else {
            var inoAgentText = '<p class="fotorama__inoagent-text">' +
                'ДАННОЕ СООБЩЕНИЕ (МАТЕРИАЛ) СОЗДАНО И (ИЛИ) РАСПРОСТРАНЕНО ' +
                'ИНОСТРАННЫМ СРЕДСТВОМ МАССОВОЙ ИНФОРМАЦИИ, ВЫПОЛНЯЮЩИМ ФУНКЦИИ ИНОСТРАННОГО АГЕНТА, ' +
                'И (ИЛИ) РОССИЙСКИМ ЮРИДИЧЕСКИМ ЛИЦОМ, ВЫПОЛНЯЮЩИМ ФУНКЦИИ ИНОСТРАННОГО АГЕНТА.</p>'
        }

        let slideContainer = videoContainer;
        let secondsLeft = 15;

        slideContainer.html('');
        let loader = document.createElement('div'),
            circle_half = document.createElement('div'),
            circle_right_half = document.createElement('div'),
            circle_inner = document.createElement('div');

        circle_half.classList.add('circle__half');
        circle_right_half.classList.add('circle__half');
        circle_right_half.classList.add('circle__half--right');
        circle_inner.classList.add('circle__inner');
        circle_inner.textContent = secondsLeft + '';

        loader.classList.add('fotorama__inoagent-loader');
        loader.appendChild(circle_half);
        loader.appendChild(circle_right_half);
        loader.appendChild(circle_inner);

        slideContainer.append(loader);

        slideContainer.append(inoAgentText);

        let intervalId = setInterval(() => {
            secondsLeft--;
            if (!$(loader).parent().length) {
                clearInterval(intervalId);
                return;
            }

            $(loader).find('.circle__inner').text(secondsLeft);

            if (secondsLeft === 0) {
                clearInterval(intervalId);
                callback();
            }
        }, 1000);
    },
    initVideoSlider: function () {
        const fotoramaOptions = window.courseVideoSlider;
        const $videoFotoramas = $('.video-block .fotorama');

        if ($videoFotoramas.length > 0) {
            if (fotoramaOptions?.slides?.length >= 1) {
                fotoramaOptions.slides.push({
                    'thumb': '',
                    'fit': 'cover',
                    'any': [],
                    'img': ''
                });
            } else {
                return false;
            }

            const $fotoramaDOM = $videoFotoramas
                .on('fotorama:show', function (e, fotorama, extra) {
                    const slide = fotorama.activeFrame;

                    if (slide.video && !slide.any.bought) {
                        const $stageFrame = slide.$stageFrame;

                        const $playButton = $stageFrame.find('.fotorama__video-play');
                        const $iframe = $stageFrame.find('iframe');

                        if ($playButton.length && !$iframe.length) {
                            setTimeout(() => {
                                $playButton.trigger('click');
                            }, 300);
                        }
                    }

                    if (fotorama.data) {
                        fotorama.data.forEach((slide) => {
                            const slideParams = slide.any;
                            if (slideParams) {
                                if (slide.$navThumbFrame !== false) {
                                    slide.$navThumbFrame.find('.fotorama__thumb__caption').remove();
                                }
                                const slideBought = slideParams.bought;
                                if (slide.$stageFrame) {
                                    if (slideBought) {
                                        const $fotoramaVideoPlay = slide.$stageFrame.find('.fotorama__video-play');
                                        $fotoramaVideoPlay.html('');
                                        $fotoramaVideoPlay.append(`
                                            <div class="btn btn-video-play">
                                                 <span class="svg-mask" style="-webkit-mask-image: url(/resources/img/icons/video-play.svg); mask-image: url(/resources/img/icons/video-play.svg); height: 43px; width: 34px;"></span>
                                            </div>
                                        `);
                                    }
                                }
                            }
                        });
                    }
                })
                .fotorama({
                    click: false,
                    arrows: 'always',
                    nav: 'thumbs',
                    width: '100%',
                    ratio: 16 / 9,
                    thumbwidth: 178,
                    thumbheight: 100,
                    data: fotoramaOptions.slides
                });

            const fotoramaObj = $fotoramaDOM.data('fotorama');
            const playVideoFunction = fotoramaObj.playVideo;
            fotoramaObj.playVideo = () => {
            };

            const preplayLogic = () => {
                if (fotoramaObj.activeFrame.inoagent) {
                    let container = fotoramaObj.activeFrame.$stageFrame.find('.fotorama__video-play');
                    app.playInoagentWarningScreen(container, () => {
                        if (fotoramaObj.activeFrame.video.id.includes('cloudfront.net')) {
                            playCustomVideo(fotoramaObj.activeFrame.video.id, container);
                        } else {
                            playVideoFunction();
                        }
                    });
                } else {
                    let container = fotoramaObj.activeFrame.$stageFrame.find('.fotorama__video-play');
                    if (fotoramaObj.activeFrame.video.id.includes('cloudfront.net')) {
                        playCustomVideo(fotoramaObj.activeFrame.video.id, container);
                    } else {
                        playVideoFunction();
                    }
                }
            };

            function playCustomVideo(videoUrl, container) {
                const iframeElement = `<iframe src="about:blank" width="100%" height="100%" frameborder="0" allowfullscreen style="background: #000;"></iframe>`;
                container.html(iframeElement);

                const iframe = container.find('iframe')[0];
                if (iframe) {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    iframeDoc.open();
                    iframeDoc.write(`
                        <html>
                            <body style="margin:0;padding:0;overflow:hidden;">
                                <video controls autoplay playsinline controlsList="nodownload" width="100%" height="100%" style="background: #000;">
                                    <source src="${videoUrl}" type="video/mp4">
                                    Your browser does not support the video tag.
                                </video>
                                <style>
                                    video::-internal-media-controls-download-button {
                                        display:none !important;
                                    }
                                    video::-webkit-media-controls-enclosure {
                                        overflow:hidden !important;
                                    }
                                    video::-webkit-media-controls-panel {
                                        width: calc(100% + 30px);
                                    }
                                </style>
                            </body>
                        </html>
                    `);
                    iframeDoc.close();

                    $(iframe).on('click', function (e) {
                        e.stopPropagation();
                    });

                    const video = iframeDoc.querySelector('video');
                    if (video) {
                        video.addEventListener('play', function () {
                            if (fotoramaObj && typeof fotoramaObj.stopAutoplay === 'function') {
                                fotoramaObj.stopAutoplay();
                            }
                        });

                        video.addEventListener('pause', function () {
                            if (fotoramaObj && typeof fotoramaObj.startAutoplay === 'function') {
                                fotoramaObj.startAutoplay();
                            }
                        });

                        video.play().catch(error => {
                            console.log("Autoplay was prevented. User interaction may be required to play the video.");
                        });

                        video.addEventListener('contextmenu', function (e) {
                            e.preventDefault();
                        });
                    }
                }

                container.on('click', function (e) {
                    e.stopPropagation();
                });
            }

            if (app.isMobile() || app.isMobileDevice()) {
                fotoramaObj.playVideo = preplayLogic;
            } else {
                $(document).on('click touch', '.fotorama__video-play', preplayLogic);
            }

            if (!fotoramaObj.activeFrame.any.bought) {
                setTimeout(() => {
                    playVideoFunction();
                }, 300);
            }

            if (fotoramaObj.data) {
                fotoramaObj.data.forEach((slide) => {
                    if (slide.video && slide.$navThumbFrame !== false) {
                        slide.$navThumbFrame.find('.fotorama__thumb').append(
                            '<div class="now-watching-overlay"><img src="/resources/img/icons/footer-youtube-ico.svg"  alt="youtube"/></div>'
                        );
                    }
                });
            }

            if (app.isMobile() && fotoramaObj.length > 1) {
                fotoramaObj.pop();
            }
        }
    },
    initContactsMap: function () {
        if (typeof ymaps !== 'undefined') {
            ymaps.ready(function () {
                var myMap = new ymaps.Map('contactsMap', {
                    center: [55.766268, 37.593924],
                    zoom: 17,
                });

                myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
                    hintContent: 'Ермолаевский переулок, 25 (м. Маяковская)',
                    balloonContent: 'Ермолаевский переулок, 25 (м. Маяковская)'
                }, {
                    // Опции.
                    // Необходимо указать данный тип макета.
                    iconLayout: 'default#image',
                    // Своё изображение иконки метки.
                    iconImageHref: app.options.assetsFolder + 'img/contacts/map-marker.svg',
                    // Размеры метки.
                    iconImageSize: [30, 42],
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    //iconImageOffset: [-5, -38]
                });

                myMap.geoObjects
                    .add(myPlacemark),
                    myMap.controls.remove('geolocationControl'),
                    myMap.controls.remove('searchControl'),
                    myMap.controls.remove('trafficControl'),
                    myMap.controls.remove('typeSelector');
            });
        }
    },
    initPreviewSlider: function () {
        const $mixedFotoramas = $('.preview-block .fotorama');

        if ($mixedFotoramas.length > 0) {
            const fotoramaOptions = window.previewMixedSlider ?? false;
            if (!fotoramaOptions) {
                return false;
            }

            const $fotoramaDOM = $mixedFotoramas
                .on('fotorama:showend', function (e, fotorama, extra) {
                    if (fotorama.activeFrame.video && !fotorama.activeFrame.any.bought) {
                        fotorama.playVideo();
                    }
                })
                .on('fotorama:loadvideo', function (e, fotorama, extra) {
                    $('.fotorama__video iframe').on('load', function () {
                        app.hideLoader($mixedFotoramas.find('.fotorama__video'));
                    });
                })
                .fotorama({
                    click: false,
                    arrows: 'always',
                    nav: 'thumbs',
                    width: '100%',
                    ratio: 16 / 9,
                    thumbwidth: 178,
                    thumbheight: 100,
                    data: fotoramaOptions.slides
                });

            const fotoramaObj = $fotoramaDOM.data('fotorama');
            fotoramaObj.data.forEach((slide) => {
                const slideParams = slide.any;

                if (slide.$stageFrame && slide.$stageFrame.find('.fotorama__video-play').length > 0) {
                    const $fotoramaVideoPlay = slide.$stageFrame.find('.fotorama__video-play');
                    if (slide.any) {
                        // $fotoramaVideoPlay.append('<div class="video-play__caption">' + slide.any.title + '</div>')
                    }

                    $fotoramaVideoPlay
                        .append(`
                            <div class="btn btn-video-play">
                                <span class="svg-mask" style="-webkit-mask-image: url(/resources/img/icons/video-play.svg); mask-image: url(/resources/img/icons/video-play.svg); height: 43px; width: 34px;"></span>
                            </div>
                        `);
                }
            });

            const playVideoFunction = fotoramaObj.playVideo;
            fotoramaObj.playVideo = () => {}

            const videoarchivePreplayLogic = () => {
                const showLoader = () => {
                    app.showLoader($mixedFotoramas.find('.fotorama__video'));
                    $('.fotorama__loaded--img img').css({ 'width': 'auto', 'height': 'auto', 'margin': 'auto' });
                    $('.pr-loader__logo').css({ 'top': '50%', 'margin-top': '-4.5em' });
                };

                if (fotoramaObj.activeFrame.inoagent) {
                    const container = fotoramaObj.activeFrame.$stageFrame.find('.fotorama__video-play');
                    app.playInoagentWarningScreen(container, () => {
                        playVideoFunction();
                        showLoader();
                    });
                } else {
                    playVideoFunction();
                    showLoader();
                }
            };

            if (app.isMobile() || app.isMobileDevice()) {
                fotoramaObj.playVideo = videoarchivePreplayLogic;
            } else {
                $(document).on('click', '.fotorama__video-play', videoarchivePreplayLogic);
            }
        }
    },
    initPersonalMenus: function () {
        if (this.isUserAuthorized()) {
            var personalMenu = this.options.personalMenu;
            var $authorizedDropdown = $(this.renderAuthorizedDropdown());
            var $formHeader = $('.user-account-form').find('.auth-form-header');

            var userConfig = window.jsConfig.user;

            if (userConfig.data.fullName) {
                $formHeader.text(userConfig.data.fullName);
            }

            $('#init-acc-content-holder').html($authorizedDropdown);

            var $personalPageMenuHolder = $('.personal-page-menu-holder');
            if ($personalPageMenuHolder.length > 0) {
                $personalPageMenuHolder.html($(this.renderPersonalPageMenu()));
            }
        }
    },
    initFavBtns: function () {
        const favCfg = window.jsConfig.fav;
        if (favCfg) {
            $(document).on('click', '.fav-btn, .cart-fav', function (e) {
                e.preventDefault();
                const $btn = $(this);
                const itemID = $btn.data('itemid');
                const action = $btn.hasClass('active') ? 'remove' : 'add';
                const url = action === 'remove' ? favCfg.removeEndpoint : favCfg.addEndpoint;

                app.preventSpamClicks($btn, false);
                app.transformFavBtn($btn, action);
                $.ajax({
                    url: url,
                    method: favCfg.reqMethod,
                    dataType: 'json',
                    data: { itemID: itemID },
                    success: function () {
                        app.preventSpamClicks($btn, true);
                    }
                });
            });
        }
    },
    transformFavBtn: function ($btn, action) {
        switch (action) {
            case 'add':
                $btn.addClass('active');
                break;
            case 'remove':
                $btn.removeClass('active');
                break;
        }
    },
    preventSpamClicks: function ($element, allow) {
        if (!allow) {
            $element.css("pointer-events", "none");
        } else {
            $element.css("pointer-events", "all");
        }
    },
    renderAuthorizedDropdown: function () {
        var returnStr = '<div class="user-account-form-authorized">\n';
        var personalMenu = app.options.personalMenu;
        if (personalMenu && personalMenu.length > 0) {
            returnStr += '<ul class="custom-list">\n';
            $.each(personalMenu, function (k, menuItem) {
                var itemClass = menuItem.active ? 'active' : '';
                returnStr += '<li><a href="' + menuItem.link + '" class="' + itemClass + '">' + menuItem.title + '</a></li>\n';
            });
            returnStr += '</ul>\n';
        }

        returnStr += '</div>';

        if (app.options.routes.logoutUrl) {
            returnStr += `<a href="${app.options.routes.logoutUrl}" class="btn btn-primary">
                <img src="${app.options.assetsFolder}img/icons/backarrow.svg">
                    Выйти
                  </a>`;
        }

        return returnStr;
    },
    renderPersonalPageMenu: function () {
        var pMenuStr = '<div class="filter-links uk-text-left">';
        var personalMenu = app.options.personalMenu;
        if (personalMenu && personalMenu.length > 0) {
            $.each(personalMenu, function (k, menuItem) {
                var itemClass = 'btn btn-outline-secondary';
                itemClass += menuItem.active ? ' active' : '';
                pMenuStr += '<a href="' + menuItem.link + '" class="' + itemClass + '">' + menuItem.title + '</a>\n';
            });
        }
        pMenuStr += '</div>';

        return pMenuStr;
    },
    showLoader: function ($container) {
        $container = typeof $container !== 'undefined' ? $container : $('body');

        if ($container.find('.pr-loader').length > 0) {
            $container.find('.pr-loader').remove();
        }
        const $loader = $(`
            <div class="pr-loader">
                <div class="pr-loader__logo">
                    <img src="${app.options.assetsFolder}img/loader-logo.webp" width="41" height="41" alt="">
                </div>
            </div>
        `);

        $loader.appendTo($container).show();
    },
    hideLoader: function ($container) {
        $container = typeof $container !== 'undefined' ? $container : $('body');

        if ($container.find('.pr-loader').length > 0) {
            setTimeout(function () {
                $container.find('.pr-loader').remove();
            }, 800);

        }
    },
    initCustomFileImgInput: function () {
        $(document).on('change', '.custom-file-input--img input', function () {
            var $this = $(this);
            var input = this;
            var usePreview = $this.attr('data-use-preview');
            var newImgUrl = false;
            if (usePreview) {
                var $targetImg = $($this.attr('data-targetimg'));
                if ($targetImg.length > 0) {
                    if (input.files && input.files[0]) {
                        var reader = new FileReader();
                        reader.readAsDataURL(input.files[0]); // convert to base64 string

                        reader.onload = function (e) {
                            $targetImg.attr('src', e.target.result);

                            var useCropper = $this.attr('data-use-cropper');

                            if (useCropper) {
                                var existingCropper = $targetImg.data('cropper');
                                if (existingCropper) {
                                    existingCropper.replace(e.target.result);
                                } else {
                                    app.initImgCropper($targetImg);
                                }
                            }
                        }
                    }
                }
            }

        });
    },
    previewFileInputImg: function (input, $targetImg) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $targetImg.attr('src', e.target.result);
            }

            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }
    },
    formatPriceRoubles: function (intPrice, currency) {
        if (currency === 'EUR') {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' \u20AC';
        }

        if (currency === 'GBP') {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' \u00A3';
        }

        if (currency === 'CHF') {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' CHF';
        }

        if (currency === 'ILS') {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' \u20AA';
        }

        if (currency === 'RUB') {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' \u20BD';
        }

        if (currency) {
            return intPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ' + currency;
        }

        return intPrice.toString();
    },
    declensionNoun: function (number, one, two, five) {
        number = Math.abs(number);
        number %= 100;
        if (number >= 5 && number <= 20) {
            return five;
        }
        number %= 10;
        if (number == 1) {
            return one;
        }
        if (number >= 2 && number <= 4) {
            return two;
        }
        return five;
    },
    filters: function () {
        if (window.innerWidth <= 1064) {
            $(document).on('click', '.mobile-filters-button', function () {
                const $menu = $('.mobile-filter-menu');

                if (!$menu.hasClass('mobile-filter-menu--sidebar-mode')) {
                    openSidebar(($menu) => {
                        wrapFilterItems($menu);

                        $menu.prepend(`
                            <div class="sidebar-header">
                                ${sidebarContentTemplateCommon}
                            </div>
                        `);

                        addSidebarFooter($menu);
                    });
                }
            });

            $(document).on('click', '.filter-item.js-filter-itemwrap', function() {
                if ($(this).hasClass('custom-checkbox-wrapper')) {
                    return;
                }

                const $menu = $('.mobile-filter-menu');
                const $filterItem = $(this).closest('.filter-item');
                const $filterList = $filterItem.find('.filter-item__list');
                const isSidebarOpen = $menu.hasClass('mobile-filter-menu--sidebar-mode');

                if (!isSidebarOpen) {
                    openSidebar();
                }

                setTimeout(() => {
                    $menu.find('.filter-item').not($filterItem).hide();
                    $menu.addClass('mobile-filter-menu--with-opened-filter-item');
                    $filterItem.addClass('filter-item--opened');
                    $filterItem.show();
                    $filterList.show();

                    if (!$menu.find('.sidebar-header').length) {
                        $menu.prepend(`
                            <div class="sidebar-header">
                                ${sidebarContentTemplateBackButton}
                            </div>
                        `);
                    } else {
                        $menu.find('.sidebar-header').html(sidebarContentTemplateBackButton);
                    }

                    wrapFilterItems($menu);
                    addSidebarFooter($menu);
                }, 200);
            });

            $(document).on('click', '.sidebar-back-button', function() {
                const $menu = $('.mobile-filter-menu');

                $menu.find('.filter-item').show();
                $menu.find('.filter-item__list').hide();
                $menu.removeClass('mobile-filter-menu--with-opened-filter-item');
                $('.filter-item--opened').removeClass('filter-item--opened');

                wrapFilterItems($menu);

                $menu.find('.sidebar-header').html(sidebarContentTemplateCommon);
            });

            $(document).on('click', '.sidebar-close-btn, .sidebar-overlay, .sidebar-footer__button--apply', function () {
                closeSidebarWithFilters();
            });
        } else {
            $(document).on('click', '.filter-item__btn', function () {
                var $filterParent = $(this).parent();
                $filterParent.siblings().removeClass('filter-item__btn-active').find('.filter-item__list').hide();
                $filterParent.find('.filter-item__list').toggle();
                $filterParent.toggleClass('filter-item__btn-active');
            });

            $(document).mouseup(function (e) {
                var container = $('.filter-item__list, .filter-item');
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $('.filter-item').each(function () {
                        $(this).removeClass('filter-item__btn-active');
                        $(this).find('.filter-item__list').hide();
                    })
                }
            });
        }

        $('.filter-item').each(function () {
            app.transformFilterItem($(this));
        });

        app.customSelectsAfterInit();
        app.countFilterItems();

        $(document).on('click', '.filter-item__btn', function () {
            app.countFilterItems();
        });

        $(document).on('click', '.filter-item__apply-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $filterItem = $(this).closest('.filter-item');
            var countCheckedCheckboxes = $filterItem.find('input[type="checkbox"]:checked').length;
            app.transformFilterItem($filterItem, countCheckedCheckboxes);
            if (app.mobile) {
                app.closeFilterItem($filterItem, true);
                $(this).closest('form').trigger('submit');
                $('.show-filters-button').click();
            } else {
                $filterItem.find('.filter-item__list').hide();
                var $form = $(this).closest('form');
                $form.trigger('submit');
            }

            closeSidebarWithFilters();

            app.countFilterItems();
        });

        $(document).on('change', '.custom-checkbox-wrapper input', function (e) {
            e.preventDefault();

            var $form = $(this).closest('form');
            $($form).find('.custom-checkbox-wrapper input').removeAttr('checked');
            $(this).attr('checked', 'checked');

            $form.trigger('submit');
            app.countFilterItems();
        });

        $(document).on('change', '.filters-body .custom-select', function (e) {
            if (app.isMobile()) {
                if (!$(this).val()) {
                    $(this).removeClass('custom-select-checked');
                    $(this).parent('.custom-select-wrapper').removeClass('custom-select-wrapper-checked');
                } else {
                    $(this).addClass('custom-select-checked');
                    $(this).parent('.custom-select-wrapper').addClass('custom-select-wrapper-checked');
                }
            } else {
                if (!$(this).val()) {
                    $(this).closest('.custom-select-wrapper').find('.select2.select2-container .select2-selection').removeClass('custom-select-checked');
                    $(this).closest('.custom-select-wrapper').removeClass('custom-select-wrapper-checked');
                } else {
                    $(this).closest('.custom-select-wrapper').find('.select2.select2-container .select2-selection').addClass('custom-select-checked');
                    $(this).closest('.custom-select-wrapper').addClass('custom-select-wrapper-checked');
                }

                var $form = $(this).closest('form');
                if ($form.length > 0) {
                    $form.trigger('submit');
                }
            }
        });


        $(document).on('click', '.filter-item__reset-icon', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $filterItem = $(this).closest('.filter-item');
            app.resetFilterItem($filterItem);
            app.transformFilterItem($filterItem);
            $filterItem.find('.filter-item__list').hide();
            $filterItem.removeClass('filter-item__btn-active');
            app.countFilterItems();

            setDataAttributeIfSidebarModeExists();
        });

        // remove all btn-filter-clean from all places?
        $(document).on('click', '.btn-filter-clean, .clear-all-filters-btn, .sidebar-footer__button--reset-all', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $filterForm = $('.filter-body__form');

            $filterForm.find('.filter-item').each(function () {
                const $this = $(this);
                app.resetAllFilterItems($this);
                app.transformFilterItem($this);
                $this.find('.filter-item__list').hide();
                $this.removeClass('filter-item__btn-active');
            });

            app.countFilterItems();
            $filterForm.trigger('submit');

            setDataAttributeIfSidebarModeExists();
        });

        $(document).on('click', '.filter-item__reset-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $filterItem = $(this).closest('.filter-item');
            app.resetFilterItem($filterItem);

            closeSidebarWithFilters();
        });
    },

    countFilterItems: function () {
        let activeFilters = 0;
        $('.filter-item').each(function () {
            activeFilters += $(this).find('input[type="checkbox"]:checked').length;
        });

        if (activeFilters > 0) {
            $('.show-filters-button').find('span').text(`Фильтры: ${activeFilters}`);
        } else {
            $('.show-filters-button').find('span').text(`Фильтры`);
        }
    },
    customSelectsAfterInit: function () {
        $('.custom-select').each(function () {
            if (app.isMobile()) {
                if (!$(this).val()) {
                    $(this).parent('.custom-select-wrapper').removeClass('custom-select-wrapper-checked');
                } else {
                    $(this).parent('.custom-select-wrapper').addClass('custom-select-wrapper-checked');
                }
            } else {
                if (!$(this).val()) {
                    $(this).closest('.custom-select-wrapper').removeClass('custom-select-wrapper-checked');
                } else {
                    $(this).closest('.custom-select-wrapper').addClass('custom-select-wrapper-checked');
                }
            }
        })
    },
    transformFilterItem: function ($filterItem) {
        var $currentFilterBtn = $filterItem.find('.filter-item__btn');
        var $currentFilterTitleSpan = $filterItem.find('.filter-btn-title');
        var countCheckedCheckboxes = $filterItem.find('input[type="checkbox"]:checked').length;

        if (countCheckedCheckboxes > 0) {
            $currentFilterTitleSpan.text($currentFilterTitleSpan.data('filter-title'));
            $currentFilterBtn.removeClass('btn-outline-secondary').addClass('btn-ico-right-close btn-secondary');
            $filterItem.find('.count-checked-checkboxes').text(countCheckedCheckboxes);
        } else {
            $currentFilterTitleSpan.text($currentFilterTitleSpan.data('filter-all-title'));
            $currentFilterBtn.removeClass('btn-ico-right-close btn-secondary').addClass('btn-outline-secondary');
            $filterItem.find('.count-checked-checkboxes').text('');
        }
    },
    openFilterItem: function ($filterItem, mobile) {
        mobile = typeof mobile !== 'undefined' ? mobile : false;

        $filterItem.toggleClass('filter-item__btn-active');
        $filterItem.find('.filter-item__list').show();
        $('.filter-item__btn').hide();
        $('.filter-item').not('.filter-item__btn-active').hide();
        $('.filters-header').hide();
        $('.filter-show-bth').hide();
        $('.mobile-filter-menu .custom-select-wrapper').hide();
    },
    closeFilterItem: function ($filterItem, mobile) {
        mobile = typeof mobile !== 'undefined' ? mobile : false;

        $filterItem.toggleClass('filter-item__btn-active');
        $('.filter-item__list').hide();
        $('.filter-item__btn').show();
        $('.filter-item').show();
        $('.filters-header').show();
        $('.filter-show-bth').show();
        $('.mobile-filter-menu .custom-select, .custom-select-wrapper').show();
    },
    resetFilterItem: function ($filterItem) {
        var $checkboxes = $filterItem.find('input[type="checkbox"]');
        $checkboxes.prop('checked', false);
        var $form = $filterItem.closest('form');
        $form.trigger('submit');
        if (app.isMobile()) {
            $('.show-filters-button').click();
        }
        app.countFilterItems();
    },
    resetAllFilterItems: function ($filterItem) {
        var $checkboxes = $filterItem.find('input[type="checkbox"]');
        $checkboxes.prop('checked', false);
        var $form = $filterItem.closest('form');
        if (app.isMobile()) {
            $('.show-filters-button').click();
        }
        app.countFilterItems();
    },
    getUrlParameter: function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    },
    customSelects: function () {
        $(document).ready(function () {
            if ($('.custom-select').length > 0) {
                $('.custom-select').select2({width: 'resolve'});
                if (!app.isMobile()) {
                    $('.custom-select').on('select2:open', function () {
                        $('.filter-item').each(function () {
                            $(this).removeClass('filter-item__btn-active');
                            $(this).find('.filter-item__list').hide();
                        })
                    })
                }
            }

            $('select').on('select2:open', function (e) {
                $('.select2-results__options').scrollbar().parent().addClass('scrollbar-inner');
            });
        });
    },
    customSelectsDeinit: function () {
        if ($('select.select2-hidden-accessible').length > 0) {
            $("select.select2-hidden-accessible").select2('destroy');
            $('.overlay').hide();
        }
    },
    isMobile: function () {
        return window.matchMedia("(max-width: 1024px)").matches;
    },
    isMobileDevice: function () {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    mobileMenu: function () {
        const $mainNavigationMenuList = $('.main-navigation-menu__list');

        $(document).on('click', '.main-navigation-menu__hamburger', function f() {

            $mainNavigationMenuList.css({
                right: '-100%',
                display: 'block'
            }).animate({
                right: '0'
            }, 300);

            $('.overlay').fadeIn(500);
            $('.overlay').css('zIndex', 5000);
            $('body').addClass('lock-overlay');
        });

        $('.main-navigation-menu__mobile-close-button').on('click', function() {
            $mainNavigationMenuList.animate({
                right: '-100%'
            }, 300, function() {
                $('.overlay').fadeOut(1);
                $('body').toggleClass('lock-overlay');
                $mainNavigationMenuList.fadeOut(1);
            });
        });

        $(document).on('click', '.overlay', function () {
            $mainNavigationMenuList.animate({
                right: '-100%'
            }, 300, function() {
                $('.overlay').fadeOut(1);
                $('body').toggleClass('lock-overlay');
                $mainNavigationMenuList.fadeOut(1);
            });
        });

        $('.main-navigation-menu__list-inner-header').click(function (e) {
            e.preventDefault();
            $(this).next('.main-navigation-menu__list-inner-list').slideToggle();
            $(this).toggleClass('main-navigation-menu__list-inner-header-open');
        });

        $('.main-navigation-menu__list-item').addClass('available');

        UIkit.util.on('.main-navigation-menu-wrapper', 'active inactive', function () {
            $('.main-header .uk-sticky-placeholder').css('height', $(this).height());
        });

        $('.admin-header__mobile > a').on('click', function () {
            $(this).parent().find('ul').slideToggle();
        });
    },
    stickyBuyButtons: function () {
        const $eventInfoAsidePrice = $('.event-info-aside__price');
        const $stickyButtons = $('.sticky-buttons');

        if (!app.mobile || $eventInfoAsidePrice.length === 0) return;

        const scrollThreshold = 400;
        let isVisible = false;

        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowBottom = scrollTop + window.innerHeight;

            const el = $eventInfoAsidePrice[0];
            const rect = el.getBoundingClientRect();
            const priceBottom = rect.top + rect.height + window.scrollY;

            const shouldShow = scrollTop > scrollThreshold && windowBottom < priceBottom;

            if (shouldShow && !isVisible) {
                $stickyButtons.stop(true, true).fadeIn(200);
                isVisible = true;
            } else if (!shouldShow && isVisible) {
                $stickyButtons.stop(true, true).fadeOut(200);
                isVisible = false;
            }
        };

        $(window).on('scroll', handleScroll);
        handleScroll();
    },
    mobileSearch: function () {
        $('.main-navigation-menu__search__button__event').on('click', 'a, button', function (e) {
            e.preventDefault();
            if (app.isMobile()) {
                let mainNavigationMenuList = $('.main-navigation-menu__list');
                $('.hamburger').addClass('is-active');
                mainNavigationMenuList.slideDown();
                $('.main-navigation-menu__list-mobile-search').show();
                $('.main-navigation-menu__list-search-from input').focus();
                $('body').addClass('lock-menu');
                mainNavigationMenuList.addClass('header-menu-mobile');
            } else {
                $('.main-header__left').fadeOut(1);
                $('.main-header__right').fadeOut(1);
                $('.main-navigation-menu__list-desktop-search').css('display', 'flex').hide().fadeIn(500);
                $('.main-navigation-menu__search__desktop').hide();
                $('.main-navigation-menu__list-search-from input').focus();
                $('.main-navigation-menu__list-desktop-search__close').on('click', function () {
                    $('.main-header__left').fadeIn(500);
                    $('.main-header__right').fadeIn(500);
                    $('.main-navigation-menu__list-desktop-search').fadeOut(1);
                    $('.main-navigation-menu__search__desktop').fadeIn(500);
                });
            }
        });
    },
    dropDownForm: function () {
        $('.show-filters-button, .dropdown-close-form').on('click', function () {
            $('.dropdown-form').toggle();
            $('.filter-show-bth .btn-primary button span').text('Показать');
        });

        $(document).on('click', '.filters-header', function (e) {
            e.stopPropagation();
            $(this).parent().find('.close-form').click();
        })

        $(document).mouseup(function (e) {
            var container = $('.dropdown-form');
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.hide();
            }
        });
    },
    sliders: function () {
        if (jQuery().owlCarousel) {
            $('.slider').on('initialized.owl.carousel changed.owl.carousel', function (e) {
                if (!e.namespace) {
                    return;
                }
                var carousel = e.relatedTarget;
                $(this).next('.slider-counter').text(carousel.relative(carousel.current()) + 1 + '/' + carousel.items().length);
            }).on('translated.owl.carousel', function (e) {
                if (!e.namespace) {
                    return;
                }
                var carousel = e.relatedTarget;
                var $currentEvent = $(this).find('.owl-item.active .calendar-event__item');
                var currentEventTime = $currentEvent.attr('data-time');
                $(this).closest('.day').find('.day__number-time').text(currentEventTime);
            }).owlCarousel({
                items: 1,
                loop: true,
                margin: 0,
                dots: false,
                nav: true,
                navText: ["<div class='nav-btn prev-slide'><img src='" + app.options.assetsFolder + "img/icons/calendar-slider-ico-left.svg'></div>", "<div class='nav-btn next-slide'><img src='" + app.options.assetsFolder + "img/icons/calendar-slider-ico-right.svg'></div>"]
            });
        }

        if ($('.hero-slider').length) {
            $('.hero-slider div.uk-slideshow').on('itemshow', function(e){
                let bColor = $(e.originalEvent.target).hasClass('black-colored') ? '#333' : '#fff';
                $('.uk-slideshow-nav > li:not(.uk-active) > a').css('borderColor', bColor);
                $('.uk-slideshow-nav > li.uk-active > a').css('borderColor', 'transparent');
            });
        }
    },
    mask: function ($input, codePrefix) {
        $input = typeof $input !== 'undefined' ? $input : false;
        codePrefix = typeof codePrefix !== 'undefined' ? codePrefix : '+7';

        if (!$input || !$input.length <= 0) {
            $input = $('.phone-input');
        }

        if (!codePrefix) {
            codePrefix = '+7';
        }
        var inputMaskMask = codePrefix.split('').join('\\') + " #{1,}";
        if ($input && $input.length > 0) {
            $input.inputmask({
                mask: inputMaskMask,
                definitions: {
                    '#': {
                        validator: "[0-9]",
                        casing: "lower"
                    }
                },
                "clearIncomplete": true,
                greedy: false
            });
        }
    },
    initPhoneCodeInput: function () {
        $(document).on('change', '.phone-code-input', function (e) {
            var $phoneinput = $($(this).attr('data-phoneinput'));
            var phoneCode = $(this).val();
            if ($phoneinput.length > 0) {
                $phoneinput.val('');
                app.mask($phoneinput, phoneCode);
            }
        })
    },
    initNewPhoneInput: function () {
        let initialCountry = 'RU';
        if (baseUrl === 'https://www.pryamaya.eu/') {
            initialCountry = 'LV'
        }

        $('.new-phone-input').each((index, item) => {
            if (typeof item !== 'undefined') {
                const intl = $(item).intlTelInput({
                    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js',
                    nationalMode: false,
                    autoPlaceholder: 'polite',
                    autoHideDialCode: false,
                    formatOnDisplay: false,
                    preferredCountries: [],
                    initialCountry: initialCountry
                });

                $(item).on('keyup', function () {
                    if ($(this).val().length === 0 || $(this).val()[0] !== '+') {
                        $(this).val('+');
                    }
                });
            }
        });
    },

    customDropdown: function () {
        const animateCloseUserAccountForm = function($form) {
            $form.animate({
                right: '-100%'
            }, 300, function() {
                $('.overlay').fadeOut(1);
                $('body').toggleClass('lock-overlay');
                $form.fadeOut(1);
            });
        };

        $(document).on('click', '.toggle-dropdown', function (e) {
            var dropdownId = $(this).attr('data-target');
            var $dropdown = $('#' + dropdownId);
            var $closeBtn = $dropdown.find('.close-form');

            if ($dropdown.hasClass('user-account-form')) {
                if (window.innerWidth < 1025) {
                    $dropdown.css({
                        right: '-100%',
                        display: 'block'
                    }).animate({
                        right: '0'
                    }, 300);

                    $('.overlay').fadeIn(500);
                    $('.overlay').css('zIndex', 5000);
                    $('body').addClass('lock-overlay');

                    return;
               } else {
                    $dropdown.toggle();

                    return;
               }
            }

            if (app.isMobile() || $(window).width() < 1065) {
                $('.overlay').fadeIn(500);
                $('.overlay').css('zIndex', 5000);
                $('.filters-header').show();
                $('body').addClass('lock-overlay');
                $dropdown.find('button[type=submit].btn-primary span').text('Показать');
            }

            $dropdown.toggle();
            $closeBtn.on('click', function () {
                $dropdown.hide();
            });
        });

        if (app.isMobile() || $(window).width() < 1065) {
            $(document).on('click', '.close-form', function () {
                var $openedModal = $('.custom-dropdown:visible');

                if ($openedModal.hasClass('user-account-form')) {
                    if (window.innerWidth < 1025) {
                        animateCloseUserAccountForm($openedModal);

                        return;
                    } else {
                        return;
                    }
                }

                $('.overlay').fadeOut(1);
                $('body').toggleClass('lock-overlay');

                if ($openedModal.length > 0) {
                    $openedModal.fadeOut(1);
                }
            });

            $(document).on('click', '.overlay', function () {
                const $openedModal = $('.custom-dropdown:visible');

                if (window.innerWidth < 1025 && $openedModal.hasClass('user-account-form')) {
                    animateCloseUserAccountForm($openedModal);

                    return;
                }

                if ($openedModal.length > 0 && !$openedModal.hasClass('mobile-filter-menu')) {
                    $('.overlay').fadeOut(1);
                    $('body').toggleClass('lock-overlay');
                    $openedModal.fadeOut(1);
                }
            });
        }

        if (window.innerWidth >= 1025) {
            $(document).on('click', '.user-account-form .close-form', function () {
                const $openedModal = $('.custom-dropdown:visible');

                $openedModal.fadeOut(1);
            });
        }

        $(document).mouseup(function (e) {
            var container = $('.custom-dropdown');
            if (!container.is(e.target) && !container.hasClass('mobile-filter-menu') && container.has(e.target).length === 0 && !$(e.target).is('.select2-results__option')) {
                if (!container.hasClass('user-account-form')) {
                    container.hide();
                }
            }
        });
    },

    initDatePickers: function () {
        $('.datepicker-init').datepicker({
            autoClose: true,
            dateFormat: "dd-mm-yyyy"
        }).each(function () {
            // console.log($(this).data('value'))
            // $(this).data("datepicker").selectDate(  new Date( this.value ) );
        });
        // $(document).on('click', '.datepicker-init', function (e) {
        //     let button = $('.datepicker-manual-handle');
        //     let datepickerinput = $(button).prev('input');
        //     $(datepickerinput).val = null;
        //     var myRegExp = "[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])";
        //     Inputmask({regex: myRegExp}).mask(datepickerinput[0]);
        //
        //     console.log(datepickerinput[0])
        // })
        $(document).on('click', '.datepicker-init', function (e) {
            let button = $(this).parent().find('.datepicker-manual-handle');
            let datepickerinput = $(button).prev('input');
            $(datepickerinput).val = null;
            var datepickerObj = datepickerinput.datepicker({
                onSelect: function(date) {

                },
                autoClose: true,
                dateFormat: "dd-mm-yyyy"
            }).data('datepicker');
            datepickerObj.show();
        })
        $(document).on('click', '.datepicker-manual-handle', function (e) {
            e.preventDefault();
            var $datepickerInput = $(this).prev('input');
            if ($datepickerInput.length > 0) {
                var datepickerObj = $datepickerInput.datepicker({
                    onSelect: function(date) {

                    },
                    autoClose: true,
                    dateFormat: "dd-mm-yyyy"
                }).data('datepicker');
                datepickerObj.show();
            }
        })
    },
    initCourseNav: function (init) {
        init = typeof init !== 'undefined' ? init : true;
        window.sliderId = '#course-nav-slider';
        if ($(sliderId).length == 0) {
            return false;
        }
        if (init) {
            UIkit.slider(sliderId, {
                finite: true,
                draggable: true
            });
            var slideIndex = false;
            var activeMenuLink = $(sliderId).find('a.active');
            var activeShown = $(sliderId).find('uk-active');
            var activeShownIndex = false;
            if (activeShown.length > 0) {
                activeShownIndex = activeShown.index();
            }
            if (activeMenuLink.length > 0) {
                slideIndex = activeMenuLink.parent().index();
            }

            if (slideIndex && slideIndex != activeShownIndex) {
                UIkit.slider(sliderId).show(slideIndex);
            }
        } else {
            UIkit.slider(sliderId).$destroy();
            $(sliderId).find('.uk-slider-items').css({
                'transform': 'none'
            });
        }
    },
    // utility
    filterObject: function () {

    },

    setBirthdayDateDatepickerValue(){
        if ($('#birthday').length) {
            let birthdayDate = $('#birthday').data('date-birthday');

            if (birthdayDate.length) {
                $('#birthday').data('datepicker').selectDate(new Date(birthdayDate));
            }
        }
    },
    initMainSlider() {
        const sliderEl = document.querySelector('.splide');
        if (!sliderEl) return;

        const splide = new Splide(sliderEl, {
            type: 'fade',
            rewind: true,
            arrows: false,
            focus: 'center',
            lazyLoad: 'nearby',
            preloadPages: 2,
            padding: 'calc((100% - 1184px) / 2)',
            pagination: true,
            speed: 1000,
            interval: 4800,
            autoplay: 'play',
            updateOnMove: true,
            classes: {
                pagination: 'splide__pagination hero-slider-pagination',
            },
        });

        const movePagination = () => {
            const pagination = splide.root.querySelector('.splide__pagination');
            const activeSlide = splide.Components.Slides.getAt(splide.index)?.slide;
            const container = activeSlide?.querySelector('.custom-pagination-container');

            if (pagination && container && !container.contains(pagination)) {
                container.appendChild(pagination);
            }
        };

        splide.on('mounted move', movePagination);
        splide.mount();
    },
    initGetActionCatch: function initGetActionCatch() {
        const getActionRef = app.getUrlParameter('action_ref');

        if (!getActionRef) return;

        setTimeout(() => {
            const isMobile = app.isMobile();
            const courseBlockExist = $('.course__start-block').length;

            let target = $('.event-info-aside');
            let offsetModifier = -170;

            if (!isMobile && courseBlockExist) {
                target = $('.course__start-block');
                offsetModifier = 500;
            }

            $('html, body').animate({
                scrollTop: target.offset().top + offsetModifier
            });
        }, 100);
    },
    initAnchorScrollToElement: function () {
        const getActionAnchor = app.getUrlParameter('anchor');
        if (!getActionAnchor) return;

        const schoolWidgetCourseExists = $('.widget-courses').length > 0;
        const eventHandler = function () {
            const footerSubscribeForm = 'footerSubscribeForm';
            const btnUserReviewShowForm = 'commentsForm';
            let anchorElement = null;

            if (getActionAnchor === footerSubscribeForm) {
                anchorElement = $('.footer-subscribe-form');
            } else if (getActionAnchor === btnUserReviewShowForm) {
                anchorElement = $('#btn-user-review-show-form');
            }

            if (anchorElement && anchorElement.length) {
                setTimeout(() => {
                    const offsetTop = anchorElement.offset().top;
                    const elementHeight = anchorElement.outerHeight();
                    const windowHeight = $(window).height();
                    const offsetCenter = offsetTop - (windowHeight / 2) + (elementHeight / 2);

                    $('html, body').animate({
                        scrollTop: offsetCenter
                    });
                }, 150);
            }
        };

        if (!schoolWidgetCourseExists) {
            eventHandler();
        } else {
            $(document.body).on('ready_widget_school_course', eventHandler);
        }
    },
    checkLocalStorage: function () {
        if (this.isUserAuthorized && localStorage.getItem(app.localStorageGoToOfflineTicketFormKey)) {
            let storageObject = JSON.parse(localStorage.getItem('go-to-offline-ticket-form-storage'));

            if (storageObject && storageObject.hasOwnProperty('url')) {
                let storageObjectUrl = storageObject.url;
                delete storageObject.url;
                let updatedStorageString = JSON.stringify(storageObject);
                console.log(updatedStorageString);
                localStorage.setItem(app.localStorageGoToOfflineTicketFormKey, updatedStorageString);

                if ($(location).attr('href') !== storageObjectUrl) {
                    window.location.href = storageObjectUrl;
                }
            }
        }
    }
};

$("document").ready(function () {
    app.init();
});

$(window).resize(function () {
    var fixed = $('.main-navigation-menu-wrapper').hasClass('uk-active');
    if (!app.isMobile()) {
        app.initDesktopMenu(fixed);
        app.customSelects();
        $('.mobile-filter-menu').removeClass('custom-dropdown').show();
        app.initCourseNav(false);
    } else {
        app.customSelectsDeinit();
        //$('.mobile-filter-menu').addClass('custom-dropdown').hide();
        //app.initCourseNav(true);
    }

    if ($(window).width() < 1065 && $(window).width() > 1024) {
        //$('.mobile-filter-menu').addClass('custom-dropdown').hide();
    }
});

$(function () {
    $('.carousel-city-filter--item').on('click', function () {
        const entityId = $(this).data('entity-id');
        const $form = $('#home-grid-filter');
        const $cityInput = $form.find('[name="city[]"]');
        const $selectedCityInput = $cityInput.filter((_, input) => Number($(input).val()) === entityId);

        if ($selectedCityInput.length) {
            $cityInput.prop('checked', false);
            $selectedCityInput.prop('checked', true)
                .closest('.dropdown-mulitselect')
                .find('.filter-item__apply-btn')
                .trigger('click');

            $('html, body').animate({
                scrollTop: $('.main-content').offset().top
            }, 1000);
        }
    });
});

// Real Height Calculation

function setRealHeight() {
    const vh = window.visualViewport?.height || window.innerHeight;
    document.documentElement.style.setProperty('--real-vh', `${vh}px`);
}


window.visualViewport?.addEventListener('resize', setRealHeight);
window.visualViewport?.addEventListener('scroll', setRealHeight);
window.addEventListener('resize', setRealHeight);
window.addEventListener('touchend', () => {
    requestAnimationFrame(setRealHeight);
    setTimeout(setRealHeight, 100);
});

setRealHeight();

// END Real Height Calculation

$(function () {
    $('.go-to-purchase-button').on('click', function () {
        const a = document.querySelector('.go-to-fienta-form');
        if (a) {
            const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
            a.dispatchEvent(evt);
        } else {
            const $target = $('#right-block-anchor');
            if ($target.length) {
                $('html, body').animate({
                    scrollTop: $target.offset().top
                }, 600);
            }
        }
    });
})

// Hidden Empty Elements Detection
function hasRealContent(el) {
    return Array.from(el.childNodes).some(node =>
        node.nodeType === 1 ||
        (node.nodeType === 3 && node.textContent.trim() !== '')
    );
}

function updateHiddenEmptyElements() {
    document.querySelectorAll('.hidden-empty').forEach(el => {
        el.classList.toggle('_is-empty', !hasRealContent(el));
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateHiddenEmptyElements();
    const observer = new MutationObserver(() => updateHiddenEmptyElements());
    observer.observe(document.body, { childList: true, subtree: true });
});

// END Hidden Empty Elements Detection
